import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["referralModal"]

  static values = {
    url: String
  }

  handleChange() {
    // I will set url value to empty string on confirm if user already
    // accept that we dont want to show it again
    if (!this.urlValue) return
    const url = this.urlValue
    this.urlValue = ""
    const isRelativePath = url.startsWith("/")
    const fullUrl = isRelativePath ? `${window.location.origin}${url}` : url
    this.referralModalTarget.setAttribute("src", fullUrl)
  }
}
